import { type FeatureModule } from '@store/features/types';

/**
 * Payments feature module configuration
 * This feature only uses RTK Query for now, no Redux slice
 */
export const payments: FeatureModule = {
  id: 'payments',
  name: 'Payments',

  dependencies: [], // Add dependency IDs if needed in the future

  reducers: {
    // No slice reducer for now - using RTK Query only
  },

  middleware: [], // RTK Query middleware is already registered at the store level via baseApi

  // No persistence needed for now - data comes from API
  persistence: {
    enabled: false,
  },

  // No sync needed for now
  sync: {
    enabled: false,
  },

  setup: _store => {
    // Feature initialization logic can be added here if needed
  },

  cleanup: _store => {
    // Feature cleanup logic can be added here if needed
  },
};
